// import React from "react";
// import { toast } from "react-toastify";
// import { Box, Button, CircularProgress, Typography } from "@mui/material";
// import AppTable from "components/Shared/AppTable";
// import FormDrawer from "components/Shared/FormDrawer";
// import BreadcrumbLayout from "layouts/BreadcrumbLayout";
// import { useTablePagination } from "hooks";
// import { useVendorProfileDetailContext } from "contexts/VendorProfileDetailContext";
// import { useCreateVendorServiceBranchesMutation, useLazyListVendorServiceBranchesQuery, useUpdateVendorServiceBranchesMutation } from "store/services/vendorProfileApi";
// import VendorServiceBranchesForm from "./VendorServiceBranchesForm ";


// const ServiceBranchesList = () => {
//     const [showForm, setShowForm] = React.useState(false);
//     const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();
//     const { vendorProfileDetail } = useVendorProfileDetailContext();

//     const columns = [
//         {
//             name: "Branch Name",
//             selector: (row) => row?.branchName,
//             cell: (row) => row?.branchName || "N/A",
//         },
//         {
//             name: "Address",
//             selector: (row) => row?.address,
//             cell: (row) => row?.address || "N/A",
//         },
//         {
//             name: "Phone",
//             selector: (row) => row?.phone,
//             cell: (row) => row?.phone || "N/A",
//         },
//     ];

//     const [updateServiceBranches, { isLoading: updatingServiceBranches }] =
//         useUpdateVendorServiceBranchesMutation();
//     const [addServiceBranches, { isLoading: addingServiceBranches }] =
//         useCreateVendorServiceBranchesMutation();

//     const [triggerFetchServiceBranches, { data: serviceBranchesRes, isLoading, isFetching, error }] =
//         useLazyListVendorServiceBranchesQuery();

//     const handleCancelForm = () => {
//         setShowForm(false);
//     };

//     const handleUpdateServiceBranches = async (data) => {
//         try {
//             await updateServiceBranches({
//                 vendorId: vendorProfileDetail?._id,
//                 branches: data.branches,
//             }).unwrap();
//             toast.success("Service branches updated successfully!");
//             handleCancelForm();
//         } catch (err) {
//             toast.error(err?.data?.message ?? "Failed to update service branches!");
//         }
//     };

//     React.useEffect(() => {
//         if (!vendorProfileDetail?._id) return;
//         triggerFetchServiceBranches({
//             vendorId: vendorProfileDetail?._id,
//             page: currentPage,
//             limit: perPage,
//         });
//     }, [vendorProfileDetail?._id, currentPage, perPage, triggerFetchServiceBranches]);

//     return (
//         <div>
//             {vendorProfileDetail?.serviceBranches.length>0 && (<Box display="flex" justifyContent="end" padding={3}>
//                 <Button
//                     variant="contained"
//                     onClick={() => setShowForm(true)}
//                 >
//                     Edit Branch
//                 </Button>
//             </Box>)}
//             <BreadcrumbLayout.Paper>
//                 {error ? (
//                     <Box padding={2}>
//                         <Typography color="error">
//                             Failed to load service branches: {error?.data?.message || "Unknown error"}
//                         </Typography>
//                     </Box>
//                 ) : serviceBranchesRes ? (
//                     <AppTable
//                         columns={columns}
//                         data={serviceBranchesRes?.data ?? []}
//                         progressPending={isLoading || isFetching}
//                         paginationServer
//                         paginationPerPage={perPage}
//                         paginationTotalRows={serviceBranchesRes?.totalItems ?? 0}
//                         paginationDefaultPage={currentPage}
//                         onChangePage={handlePageChange}
//                         onChangeRowsPerPage={handlePerRowsChange}
//                     />
//                 ) : (
//                     <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
//                         <CircularProgress size={24} />
//                         <Typography variant="body2" marginLeft={1}>
//                             Loading Service Branches...
//                         </Typography>
//                     </Box>
//                 )}
//             </BreadcrumbLayout.Paper>
//             <FormDrawer
//                 title="Edit Service Branches"
//                 open={showForm}
//                 onClose={handleCancelForm}
//             >
//                 <VendorServiceBranchesForm
//                     isBusy={updatingServiceBranches}
//                     vendorServiceBranchesDetail={{
//                         serviceBranches: serviceBranchesRes?.data || [],
//                     }}
//                     onSubmit={handleUpdateServiceBranches}
//                     onCancel={handleCancelForm}
//                     vendorId={vendorProfileDetail?._id}
//                     vendor={vendorProfileDetail?.vendor?.name || ""}
//                 />
//             </FormDrawer>
//         </div>
//     );
// };

// export default ServiceBranchesList;

import React from "react";
import { toast } from "react-toastify";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import AppTable from "components/Shared/AppTable";
import FormDrawer from "components/Shared/FormDrawer";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useTablePagination } from "hooks";
import { useVendorProfileDetailContext } from "contexts/VendorProfileDetailContext";
import {
    useCreateVendorServiceBranchesMutation,
    useLazyListVendorServiceBranchesQuery,
    useUpdateVendorServiceBranchesMutation,
} from "store/services/vendorProfileApi";
import VendorServiceBranchesForm from "./VendorServiceBranchesForm ";


const ServiceBranchesList = () => {
    const [showForm, setShowForm] = React.useState(false);
    const [isEditMode, setIsEditMode] = React.useState(false); // Track edit or add mode
    const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();
    const { vendorProfileDetail } = useVendorProfileDetailContext();

    const columns = [
        {
            name: "Branch Name",
            selector: (row) => row?.branchName,
            cell: (row) => row?.branchName || "N/A",
        },
        {
            name: "Address",
            selector: (row) => row?.address,
            cell: (row) => row?.address || "N/A",
        },
        {
            name: "Phone",
            selector: (row) => row?.phone,
            cell: (row) => row?.phone || "N/A",
        },
    ];

    const [updateServiceBranches, { isLoading: updatingServiceBranches }] =
        useUpdateVendorServiceBranchesMutation();
    const [addServiceBranches, { isLoading: addingServiceBranches }] =
        useCreateVendorServiceBranchesMutation();
    const [triggerFetchServiceBranches, { data: serviceBranchesRes, isLoading, isFetching, error }] =
        useLazyListVendorServiceBranchesQuery();

    const handleCancelForm = () => {
        setShowForm(false);
        setIsEditMode(false); // Reset mode when closing form
    };

    const handleUpdateServiceBranches = async (data) => {
        try {
            await updateServiceBranches({
                vendorId: vendorProfileDetail?._id,
                branches: data.branches,
            }).unwrap();
            toast.success("Service branches updated successfully!");
            handleCancelForm();
        } catch (err) {
            toast.error(err?.data?.message ?? "Failed to update service branches!");
        }
    };

    const handleAddServiceBranches = async (data) => {
        try {
            await addServiceBranches({
                vendorId: vendorProfileDetail?._id,
                branches: data.branches,
            }).unwrap();
            toast.success("Service branches added successfully!");
            handleCancelForm();
        } catch (err) {
            toast.error(err?.data?.message ?? "Failed to add service branches!");
        }
    };

    React.useEffect(() => {
        if (!vendorProfileDetail?._id) return;
        triggerFetchServiceBranches({
            vendorId: vendorProfileDetail?._id,
            page: currentPage,
            limit: perPage,
        });
    }, [vendorProfileDetail?._id, currentPage, perPage, triggerFetchServiceBranches]);

    return (
        <div>
            <Box display="flex" justifyContent="end" padding={3}>
                {vendorProfileDetail?.serviceBranches?.length > 0 ? (
                    <Button
                        variant="contained"
                        onClick={() => {
                            setShowForm(true);
                            setIsEditMode(true); // Set to edit mode
                        }}
                    >
                        Edit Branch
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        onClick={() => {
                            setShowForm(true);
                            setIsEditMode(false); // Set to add mode
                        }}
                    >
                        Add Branch
                    </Button>
                )}
            </Box>
            <BreadcrumbLayout.Paper>
                {error ? (
                    <Box padding={2}>
                        <Typography color="error">
                            Failed to load service branches: {error?.data?.message || "Unknown error"}
                        </Typography>
                    </Box>
                ) : serviceBranchesRes ? (
                    <AppTable
                        columns={columns}
                        data={serviceBranchesRes?.data ?? []}
                        progressPending={isLoading || isFetching}
                        paginationServer
                        paginationPerPage={perPage}
                        paginationTotalRows={serviceBranchesRes?.totalItems ?? 0}
                        paginationDefaultPage={currentPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                    />
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
                        <CircularProgress size={24} />
                        <Typography variant="body2" marginLeft={1}>
                            Loading Service Branches...
                        </Typography>
                    </Box>
                )}
            </BreadcrumbLayout.Paper>
            <FormDrawer
                title={isEditMode ? "Edit Service Branches" : "Add Service Branches"}
                open={showForm}
                onClose={handleCancelForm}
            >
                <VendorServiceBranchesForm
                    isBusy={isEditMode ? updatingServiceBranches : addingServiceBranches}
                    vendorServiceBranchesDetail={
                        isEditMode
                            ? { serviceBranches: serviceBranchesRes?.data || [] }
                            : null // Pass null for add mode to reset form
                    }
                    onSubmit={isEditMode ? handleUpdateServiceBranches : handleAddServiceBranches}
                    onCancel={handleCancelForm}
                    vendorId={vendorProfileDetail?._id}
                    vendor={vendorProfileDetail?.vendor?.name || ""}
                />
            </FormDrawer>
        </div>
    );
};

export default ServiceBranchesList;